"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.saveProfileToLocalStorage = void 0;
// eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
var saveProfileToLocalStorage = function (key, profile) {
    if (profile === null) {
        localStorage.removeItem(key);
        return;
    }
    localStorage.setItem(key, JSON.stringify(profile));
};
exports.saveProfileToLocalStorage = saveProfileToLocalStorage;
//# sourceMappingURL=utils.js.map